function scriptLoader(scriptUrl, isModule, defer) {
    const script = document.createElement('script');
    script.src = scriptUrl;
    if (isModule) {
        script.type = "module";
    }
    if (defer) {
        script.defer = true;
    }
    else {
        script.async = true;
    }
    document.body.appendChild(script);
    return new Promise((resolve, reject) => {
        script.onload = () => {
            resolve();
        };
        script.onerror = () => {
            reject();
        };
    });
}
export default scriptLoader;
